import { useEffect, useState, useCallback } from 'react';

import CaixaService from '@services/CaixaService';

const useCaixas = (processo) => {
    const [ data, setData ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchData = useCallback(() => {
        setLoading(true);

        if (!processo)
            return;

        CaixaService.listar(processo, [{ field: 'paginacao', value: false }])
            .then(res => setData(res.data.map(c => ({ label : c.codigo, value : c.id }) )))
            .catch(err => setError(err))
            .finally(() => setLoading(false));
    }, [processo]);

    useEffect(() => fetchData(), [fetchData]);

    return { data, loading, error };
}

export default useCaixas;